/** Shared constants used across multiple pages */

export const MEMBER_COLOURS = ['#a43917', '#426464', '#48653f', '#c5512d', '#8a7268'];

export const initials = (name: string) =>
  name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);
